// Crossovers and Suvs defined sort order
var __crossoversAndSuvsSortOrder = [
  'c-hr',
  'rav4',
  'rav4hybrid',
  'highlander',
  'highlanderhybrid',
  '4runner',
  'sequoia',
  'landcruiser'
];

export default function sortCrossoversAndSuvsList(crossoversAndSuvsArray, mode) {
  // compare landing uses series raw while the nav uses the transform done
  // by series.latest.js, which is why the different 'seriesCode' vs. 'series_code'
  if (mode && mode === 'compare') {
    crossoversAndSuvsArray.sort(function (a, b) {
      return __crossoversAndSuvsSortOrder.indexOf(a.seriesCode)
              - __crossoversAndSuvsSortOrder.indexOf(b.seriesCode);
    });
  } else {
    crossoversAndSuvsArray.sort(function (a, b) {
      return __crossoversAndSuvsSortOrder.indexOf(a.series_code)
        - __crossoversAndSuvsSortOrder.indexOf(b.series_code);
    });
  }

  return crossoversAndSuvsArray;
}
